export default "__VITE_ASSET__C$BlPN0g__"